import { Box, Typography } from '@wishket/design-system';
import { forwardRef } from 'react';

import { PATH } from '@/shared/constants';
import { BubblePopover, Link } from '@/shared/Components';
import { useDeviceCheck } from '@/shared/hooks';

interface CollectionScrapTooltipProps {
  isOpen: boolean;
}

interface CollectionScrapTooltipContentProps {
  isDesktop: boolean;
}

const CollectionScrapTooltipContent = ({
  isDesktop,
}: CollectionScrapTooltipContentProps) => {
  return (
    <Box className="flex w-[215px] flex-col break-keep rounded-xl bg-w-white px-4 py-3 shadow-graymedium">
      <Typography variant="body2" className="text-w-gray-900">
        컬렉션이 스크랩되었어요.
      </Typography>
      <Typography variant="body2" className="text-w-gray-900">
        <Link
          href={PATH.MY_COLLECTION_SCRAP}
          data-testid="collection-scrap-tooltip-link"
          className="font-medium text-primary hover:underline"
        >
          {isDesktop ? `[내 컬렉션]` : `내 컬렉션`}
        </Link>
        에서 확인해 보세요.
      </Typography>
    </Box>
  );
};

const CollectionScrapTooltip = forwardRef<
  HTMLDivElement,
  CollectionScrapTooltipProps
>(({ isOpen }: CollectionScrapTooltipProps, ref) => {
  const { isDesktop } = useDeviceCheck();
  return (
    <BubblePopover
      open={isOpen}
      variant={isDesktop ? 'left' : 'up'}
      content={<CollectionScrapTooltipContent isDesktop={isDesktop} />}
      className="absolute -top-1 left-1/2 desktop:left-1/4 desktop:top-1/2"
      ref={ref}
    />
  );
});

CollectionScrapTooltip.displayName = 'CollectionScrapTooltip';

export default CollectionScrapTooltip;
